module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/photo-studio-og-image-8db7ee15f183efbf6c2437a865951562.png";